<!--
 * @Author: wsx
 * @Date: 2022-03-05 14:27:03
 * @LastEditTime: 2022-03-05 18:31:30
 * @Description:警情事件
 * @FilePath: \smart-community\src\views\smartApplication\threeSolidQuery\components\policeSituation.vue
-->
<template>
  <div class="policeSituation">
    <div class="search-results-box">
      <ul class="search-results">
        <template v-for="item in securitylist" :key="item">
          <li class="results-item">
            <div class="item-img">
              <img v-if="item.fileId" :src="item.fileId" alt="" />
              <img v-else src="~@/assets/images/moren.png" alt="" />
            </div>
            <div class="item-details">
              <div class="details-info">
                <span class="label">事件名称</span>
                <span class="value"> {{ item.eventName }}</span>
              </div>
              <div class="details-info">
                <span class="label">事件类型</span>
                <span class="value"> {{ eventTypeData(item.state) }}</span>
              </div>
              <div class="details-info">
                <span class="label">事发地点</span>
                <span class="value"> {{ item.eventAddress }}</span>
              </div>
              <div class="details-info">
                <span class="label">开始时间</span>
                <span class="value"> {{ item.handleTime }}</span>
              </div>
              <div class="details-info">
                <span class="label">结束时间</span>
                <span class="value"></span>
              </div>
              <div class="details-info">
                <span class="label">上报时间</span>
                <span class="value"> {{ item.reportTime }}</span>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import { eventqueryAssignEvent } from "@/api/eventManagement/eventManagementApi.js";
export default defineComponent({
  name: "policeSituation",
  setup(props) {
    const data = reactive({
      securitylist: [],
    });
    const refData = toRefs(data);
    // 请求数据
    const queryData = (params) => {
      console.log("policeSituation-请求数据-参数", params);
      return geteventqueryAssignEventlist(params);
    };
    // 获取安防设备
    const geteventqueryAssignEventlist = async (search) => {
      const params = {
        page: 1,
        limit: 10000,
      };
      if (search) {
        params.search = search;
      }
      const res = await eventqueryAssignEvent(params);
      data.securitylist = res.page.list;
      return res.page.list.length;
    };
    geteventqueryAssignEventlist();
    const eventTypeData = (is) => {
      let str = "";
      switch (is) {
        case "1":
          str = "打架斗殴";
          break;
        case "2":
          str = "非法游行";
          break;
        case "3":
          str = "噪音扰民";
          break;
        case "4":
          str = "领里纠纷";
          break;
        default:
          break;
      }
      return str;
    };
    return { ...refData, queryData, eventTypeData };
  },
});
</script>
<style lang="scss" scoped>
.policeSituation {
  .search-results-box {
    width: 100%;
    flex: 1;
    height: 100%;
    overflow: auto;
  }
  .search-results {
    width: 100%;
    .results-item {
      padding: 10px 0;
      width: 100%;
      border-bottom: 1px solid #aab2c5;
      @include flex-row-s-c;
      .item-img {
        width: 100px;
        img {
          width: 100%;
        }
      }
      .item-details {
        flex: 1;
        margin-left: 10px;
        line-height: 26px;
        padding: 3px 0;
        .details-info {
          font-size: 14px;
          .label {
            padding-right: 5px;
          }
        }
      }
    }
  }
}
</style>
